/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { object, string, bool } from 'prop-types';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import useStyles from './ProductItemStyles';
import { setProductPrefixPath } from '../../../../../helpers/determineInternationalizationPath';
import LazyImage from './LazyImage';
import ProductTitle from './ProductTitle';
import LazyLoadComponent from './LazyLoadComponent/LazyLoad';
import Favorite from '../../../WishlistPage/Favorite';

import { actions as tagManagerActions } from '../../../../../../state/ducks/TagManager/ducks/TagManager';

import { priceInText } from '../../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceRange';

const ProductItem = (props) => {
    const [loaded, setLoaded] = useState(false);
    const dispatch = useDispatch();
    const [productHovering, setProductHovering] = useState(false);
    const {
        item, presentationFamily, isZodiacProduct, isPlantsForOccasions, brand,
    } = props;
    const isPlants = brand?.code === 'PLA';
    const styles = useStyles();
    const itemPath = isZodiacProduct ? item : item?.item;
    // image onLoad handler to update state to loaded
    const onLoad = () => {
        setLoaded(true);
    };
    const handleEventClick = () => {
        if (isPlantsForOccasions) {
            dispatch(tagManagerActions.trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Homepage',
                eventAction: 'Click',
                eventLabel: `Plants For Occasions - ${item?.link?.title} - ${itemPath?.name}`,
            }));
        } else if (item?.isTopTrendingProduct) {
            dispatch(tagManagerActions.trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Homepage',
                eventAction: 'Click',
                eventLabel: `Most Loved By Our Customers - ${itemPath.name}`,
            }));
        }
    };
    const getProductImage = (getDOM) => {
        if (itemPath.productCategory && itemPath.productCategory === 'search') {
            return getDOM;
        }
        return <LazyLoadComponent lazyLoad={{ height: '200', once: true }}>{getDOM}</LazyLoadComponent>;
    };

    const classNames = `${loaded ? 'productImage' : 'imageContainer'}`;
    const defaultImg = `https:${itemPath.image?.path}/${itemPath.image?.name}x.jpg`;

    const getProductLink = () => setProductPrefixPath(itemPath.seo?.url);

    const srcSet = `https:${itemPath.image?.path}/${itemPath.image?.name}x.jpg`;
    const getDOM = (
        <>
            <div className={`${classNames} product-item-view`}>
                <LazyImage srcSet={srcSet} src={defaultImg} alt={itemPath.name} onLoad={onLoad} width="100%" height="100%" onClick={undefined} />
                {itemPath?.image?.snipe && <span role="region" aria-label="product name" className="productLabel product-label" style={{ backgroundColor: 'rgb(69, 134, 6)' }}>{itemPath?.image?.snipe}</span>}
            </div>
        </>
    );

    const priceRangeText = priceInText(null, itemPath.skuPriceRange, presentationFamily);
    const productName = itemPath && itemPath.name ? itemPath.name : '';
    const productLabel = productName && priceRangeText ? `${productName}${priceRangeText}` : productName;
    return (
        <div onMouseEnter={() => { setProductHovering(true); }} onMouseLeave={() => { setProductHovering(false); }}>
            <Grid container className={styles.productItemContainerWrapper}>
                <Link to={getProductLink()} onClick={handleEventClick} passhref="true" prefetch="false" tabIndex="-1" aria-label={itemPath ? productLabel : 'Product'}>
                    <div className={`slider productItem ${isPlantsForOccasions ? '' : 'productItemContainer'}`}>
                        {getProductImage(getDOM)}
                        <ProductTitle isZodiacProduct={isZodiacProduct} isPlantsForOccasions={isPlantsForOccasions} product={itemPath} presentationFamily={presentationFamily} />
                    </div>
                </Link>
            </Grid>
            {isPlants && <Favorite partNumber={itemPath.id} hover={productHovering} showError={!!isPlantsForOccasions} /> }
        </div>
    );
};

ProductItem.propTypes = {
    item: object.isRequired,
    presentationFamily: string.isRequired,
    isZodiacProduct: bool,
    isPlantsForOccasions: bool,
    brand: object.isRequired,
};

ProductItem.defaultProps = {
    isZodiacProduct: false,
    isPlantsForOccasions: false,
};

export default ProductItem;
